
import { BaseConverter } from "./base.converter";
import { hostConverter } from "./host.converter";
import { PlainAccomodation } from "@models/plain-accomodation.model";
import { PlainAccomodationDto } from "@dtos/plain-accomodation.dto";

export class PlainAccomodationConverter extends BaseConverter<PlainAccomodation, PlainAccomodationDto>{
    private hostConverter = new hostConverter()
    modelToDto(model: PlainAccomodation): PlainAccomodationDto {
        return new PlainAccomodationDto(
            model.id,
            model.name,
            model.fullAddress,
            model.latitude,
            model.longitude,
            model.qrCodeImg,
            model.active,
            model.creationDate?.toISOString(),
            model.updateDate?.toISOString(),
            model.logo,
            model.imgMobile,
            model.imgDesktop,
            model.qrCodeId,
            model.lastVisitDate?.toISOString(),
            model.host? this.hostConverter.modelToDto(model.host): undefined
        )
    }

    dtoToModel(dto: PlainAccomodationDto): PlainAccomodation {
        return new PlainAccomodation(
            dto.id,
            dto.name,
            dto.fullAddress,
            dto.latitude,
            dto.longitude,
            dto.qrCodeImg,
            dto.active,
            dto.creationDate? new Date(dto.creationDate) : undefined,
            dto.updateDate? new Date(dto.updateDate) : undefined,
            dto.logo,
            dto.imgMobile,
            dto.imgDesktop,
            dto.qrCodeId,
            dto.lastVisitDate? new Date(dto.lastVisitDate) : undefined,
            dto.host ? this.hostConverter.dtoToModel(dto.host) : undefined
        )
        
    }
}